import { HYDRATE } from "next-redux-wrapper";
import { ActionsWishlist } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storeWishlist(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storeWishlist };

	}
	case ActionsWishlist.LOAD_GET_WISHLIST:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsWishlist.RES_GET_WISHLIST:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsWishlist.ERR_GET_WISHLIST:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storeWishlist;
